import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Checkbox from "@amzn/meridian/checkbox";
import ControlGroup from "@amzn/meridian/control-group";
import {optionsAddedOrChanged} from "../../actions/OptionsActions";
import {FormattedMessage} from "react-intl";

class MachineStatusOptions extends Component {
    render() {

        const {selectedStatuses} = this.props;
        return (
            <ControlGroup label={<FormattedMessage id="machineStatusOption.active" defaultMessage="Active"/>}
                          onChange={updatedStatuses => this.handleStatusesChange(updatedStatuses)}
                          value={selectedStatuses}>
                <Checkbox data-cy={"machineStatusFieldsetOption"} key="Active" value="Active">
                    <FormattedMessage id="machineStatusOptions.yes" defaultMessage="Yes"/>
                </Checkbox>
                <Checkbox data-cy={"machineStatusFieldsetOption"} key="Inactive" value="Inactive">
                    <FormattedMessage id="machineStatusOption.no" defaultMessage="No"/>
                </Checkbox>
            </ControlGroup>
        )
    }

    handleStatusesChange(updatedStatuses) {
        this.props.dispatch(optionsAddedOrChanged(
            {
                'machineStatuses': updatedStatuses
            }
        ))
    }
}

const mapStateToProps = state => ({
    selectedStatuses: state.optionsReducer.options.machineStatuses
});
export default withRouter(connect(mapStateToProps)(MachineStatusOptions));



// WEBPACK FOOTER //
// ./src/components/options/MachineStatusOptions.js